import React from 'react';
import { PLAN_BENEFITS } from '../../data/welding';

/** Compact problem → plan bridge between the preview and the technical proof. */
export function PlanSection() {
  return <section aria-labelledby="plan-title" className="bg-surface py-14 sm:py-20" data-id="element-228" data-mp="16x2jarix2t8r">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-5 sm:px-8 lg:grid-cols-12 lg:items-end lg:gap-14" data-id="element-229" data-mp="16v9cnc8b090r">
        <div className="lg:col-span-6" data-id="element-230" data-mp="f668dwgf2yo4">
          <h2 id="plan-title" className="font-heading text-[2rem] font-bold uppercase leading-[0.98] text-white min-[390px]:text-[2.15rem] sm:text-[2.7rem] lg:text-[3rem]" data-id="element-231" data-mp="f77mk9sqc1a2">
            VOUS SAVEZ SOUDER. COMMENCEZ AVEC UN PLAN CLAIR.
          </h2>
          <p className="mt-4 max-w-xl text-[1rem] leading-relaxed text-steel-pale sm:text-[1.08rem]" data-id="element-232" data-mp="sycmld00evkx">
            La fabrication, c’est votre savoir-faire. La collection vous donne une base pratique pour préparer chaque
            projet : cotes, pièces en acier, informations de débit, vues techniques et séquence d’assemblage.
          </p>
        </div>

        <ol className="grid gap-0 sm:grid-cols-3 sm:border-t sm:border-arc/40 lg:col-span-6" data-id="element-233" data-mp="1wyhiz8qudslb">
          {PLAN_BENEFITS.map(benefit => <li key={benefit} className="relative border-l border-arc/40 py-3 pl-5 sm:border-l-0 sm:pl-0 sm:pr-5 sm:pt-6" data-id="element-234" data-mp="1s6r5itwlyopo">
              <span className="absolute -left-[5px] top-[18px] h-[9px] w-[9px] rotate-45 border border-arc bg-surface sm:-top-[5px] sm:left-0" aria-hidden data-id="element-235" data-mp="1i9d0rrk1rod7" />
              <p className="font-heading text-[1.3rem] font-semibold uppercase leading-tight text-white" data-id="element-236" data-mp="198n6isafq61l">{benefit}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}